import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealer";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
addToChainAfter(chain, RequestDataFromApi, props => {
    if (props.parameter.id !== props.apiResult.id) {
        const dealerId = props.apiResult.id;
        if(props.apiResult?.state !==null){
            props.apiResult = {
                ...props.apiResult,
                id: props.apiResult.properties["dealerCustomURL"] && props.apiResult.properties["dealerCustomURL"] !== "" ?
                `${props.apiResult.properties["dealerCustomURL"]}-${props.apiResult.state?.toLowerCase()}`
                : `${props.apiResult.name.toLowerCase().replace('&','and')}-${props.apiResult.state.toLowerCase()}`,
                properties: {
                    ...props.apiResult.properties,
                    dealerId,
                },
            };
        }
    }
});
